import { APEX_CLASS, APEX_TRIGGER } from '@server/parser';

export enum ActiveState {
  activeOnly = 'activeOnly',
  activeAndInactive = 'activeAndInactive',
}

export const apexConfigurationTypes = [
  { label: 'Class', value: APEX_CLASS },
  { label: 'Trigger', value: APEX_TRIGGER },
];

export const activeFilterOptions = [
  { label: 'Only active', value: ActiveState.activeOnly },
  { label: 'Active and inactive', value: ActiveState.activeAndInactive },
];
